import { SegmentedFilter, type SegmentedFilterVariant } from '@/components/ui/SegmentedFilter';

const OPTIONS = [
  { value: 0, label: 'All' },
  { value: 2, label: 'VLCC' },
  { value: 3, label: 'Suezmax' },
] as const;

interface VesselSizeFilterProps {
  /** 0 = All, 2 = VLCC, 3 = Suezmax */
  value: number;
  onChange: (vesselSizeId: number) => void;
  /**
   * `segmented` — gray-container/blue-pill tabs matching the /baltic page
   * "Historical trends" selector (used on the Recent Fixtures page).
   * `compact` — slim flex buttons matching the dashboard Baltic widget
   * (used in the Recent Fixtures dashboard widget).
   */
  variant?: SegmentedFilterVariant;
  /**
   * Vessel size ids the user's company may not view (e.g. Suezmax without a Suezmax pool).
   * Those options are hidden; `All` is always shown.
   */
  disallowedVesselSizeIds?: number[];
  className?: string;
}

/**
 * Three-way vessel-size toggle (All | VLCC | Suezmax) for Recent Fixtures.
 * Each variant mirrors the Baltic selector used in the same context.
 */
export function VesselSizeFilter({
  value,
  onChange,
  variant = 'segmented',
  disallowedVesselSizeIds = [],
  className = '',
}: VesselSizeFilterProps) {
  // Always keep "All" (0); hide any gated option the user's company cannot view.
  const options = OPTIONS.filter(
    (opt) => opt.value === 0 || !disallowedVesselSizeIds.includes(opt.value)
  );

  return (
    <SegmentedFilter
      options={options}
      value={value}
      onChange={onChange}
      variant={variant}
      ariaLabel="Vessel size"
      className={className}
    />
  );
}
